import { Injectable, signal, computed, effect } from '@angular/core';

export type AppTheme = 'light' | 'dark' | 'system'; //system: fallback dove decide il browser con le sue impostazioni

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private storageKey = 'app-theme';

  private themeSignal = signal<AppTheme>(this.getInitialTheme());

  theme = this.themeSignal.asReadonly();

  effectiveTheme = computed<'light' | 'dark'>(() => {
    const theme = this.themeSignal();

    if (theme === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    return theme;
  });

  constructor() {
    effect(() => {
      this.applyTheme(this.themeSignal());
    });

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', () => {
      if (this.themeSignal() === 'system') {
        this.applyTheme('system');
      }
    });
  }

  setTheme(theme: AppTheme): void {
    this.themeSignal.set(theme);
    localStorage.setItem(this.storageKey, theme);
  }

  toggleTheme(): void {
    const current = this.effectiveTheme();
    this.setTheme(current === 'dark' ? 'light' : 'dark');
  }

  private getInitialTheme(): AppTheme {
    const savedTheme = localStorage.getItem(this.storageKey);

    if (savedTheme === 'light' || savedTheme === 'dark' || savedTheme === 'system') {
      return savedTheme;
    }

    return 'system';
  }

  private applyTheme(theme: AppTheme): void {
    const root = document.documentElement;

    root.classList.remove('theme-light', 'theme-dark');

    if (theme === 'light') {
      root.classList.add('theme-light');
      return;
    }

    if (theme === 'dark') {
      root.classList.add('theme-dark');
      return;
    }
  }
}